import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Navbar from './Components/Navbar';
import Footer from '../Components/Footer';
import PageHeroBanner from './Components/PageHeroBanner';
import { fetchBlogs } from '../data/blogs';
import './Blog.css';

function BlogPage() {
  const navigate = useNavigate();
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => { window.scrollTo(0, 0); }, []);

  useEffect(() => {
    let active = true;
    (async () => {
      const data = await fetchBlogs();
      if (active) { setBlogs(data || []); setLoading(false); }
    })();
    return () => { active = false; };
  }, []);

  return (
    <>
      <Navbar />
      <div className="blog-hero-wrap" style={{ marginTop: '5rem' }}>
        <PageHeroBanner
          heading="The Journal"
          image="/bgimage.jpeg"
          eyebrow="From the Journal"
          description="Stories, Wellness & the World of Elaichi"
        />
      </div>

      <div className="blog-page">
        {loading ? (
          <p className="blog-empty">Loading…</p>
        ) : blogs.length === 0 ? (
          <p className="blog-empty">No journal posts yet. Check back soon.</p>
        ) : (
          <div className="blog-list-grid">
            {blogs.map((post) => (
              <article
                key={post._id || post.slug}
                className="blog-list-card"
                role="button"
                tabIndex={0}
                onClick={() => navigate(`/blog/${post.slug}`)}
                onKeyDown={(e) => { if (e.key === 'Enter') navigate(`/blog/${post.slug}`); }}
              >
                {post.image && (
                  <div className="blog-list-thumb">
                    <img src={post.image} alt={post.title} />
                  </div>
                )}
                <div className="blog-list-body">
                  {post.category && <span className="blog-list-category">{post.category}</span>}
                  <h3 className="blog-list-title">{post.title}</h3>
                  <p className="blog-list-excerpt">{post.excerpt}</p>
                  <span className="blog-list-readtime">{post.readTime || 'Read more'} →</span>
                </div>
              </article>
            ))}
          </div>
        )}
      </div>

      <Footer />
    </>
  );
}

export default BlogPage;
